"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;
exports.saveCurrentClientPermissions = exports.getCurrentClientPermissions = exports.ACTIONS = void 0;

var _ = require(".");

var _spec = require("./spec");

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var resource = _spec.RESOURCES.clientPermissions;
var initialState = {
  data: {},
  errors: {},
  isLoading: false,
  pendingRequests: 0,
  currentClientPermissions: {
    permissions: {
      create: false,
      read: false,
      update: false,
      destroy: false
    },
    permissions_subscriptions: {
      create: false,
      read: false,
      update: false,
      destroy: false
    },
    permissions_contact_persons: {
      create: false,
      read: false,
      update: false,
      destroy: false
    }
  }
};
var ACTIONS = {
  GET_CURRENT_CLIENT_PERMISSIONS: new _.Action('GET_CURRENT_CLIENT_PERMISSIONS'),
  SAVE_CURRENT_CLIENT_PERMISSIONS: new _.Action('SAVE_CURRENT_CLIENT_PERMISSIONS')
};
exports.ACTIONS = ACTIONS;

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentPendingRequests;

  switch (action.type) {
    case resource.actions.list.main:
    case resource.actions.create.main:
    case resource.actions.update.main:
    case resource.actions.retrieve.main:
    case resource.actions.destroy.main:
      currentPendingRequests = state.pendingRequests + 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case resource.actions.list.success:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: (0, _lodash.keyBy)(action.payload.results, 'id'),
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case resource.actions.create.success:
    case resource.actions.update.success:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, _defineProperty({}, action.payload.id, action.payload)),
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0,
        errors: {}
      });

    case resource.actions.retrieve.success:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, _defineProperty({}, action.payload.id, action.payload)),
        currentClientPermissions: action.payload,
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0,
        errors: {}
      });

    case resource.actions.destroy.success:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: (0, _lodash.omit)(state.data, action.meta.object.id),
        errors: {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case ACTIONS.SAVE_CURRENT_CLIENT_PERMISSIONS.main:
      return {
        currentClientPermissions: {
          permissions: action.payload.permissions,
          permissions_subscriptions: action.payload.permissions_subscriptions,
          permissions_contact_persons: action.payload.permissions_contact_persons
        }
      };

    case resource.actions.list.fail:
    case resource.actions.create.fail:
    case resource.actions.retrieve.fail:
    case resource.actions.update.fail:
    case resource.actions.destroy.fail:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: action.payload,
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    default:
      return state;
  }
}

var getCurrentClientPermissions = function getCurrentClientPermissions(clientID, entityProfileID) {
  return {
    type: ACTIONS.GET_CURRENT_CLIENT_PERMISSIONS.main,
    payload: {
      client_id: clientID,
      entity_profile_id: entityProfileID
    }
  };
};

exports.getCurrentClientPermissions = getCurrentClientPermissions;

var saveCurrentClientPermissions = function saveCurrentClientPermissions(permissions, permissionsSubscriptions, permissionsContactPersons) {
  return {
    type: ACTIONS.SAVE_CURRENT_CLIENT_PERMISSIONS.main,
    payload: {
      permissions: permissions,
      permissions_subscriptions: permissionsSubscriptions,
      permissions_contact_persons: permissionsContactPersons
    }
  };
};

exports.saveCurrentClientPermissions = saveCurrentClientPermissions;